var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.93804 1.59261L7.16478 1.56803C10.1275 1.37737 12.6 3.76065 12.6 6.74456C12.6 8.56514 11.6956 10.2971 10.5971 11.7227C9.50332 13.1422 8.25262 14.212 7.63795 14.7004L7.63705 14.7012C7.54593 14.774 7.4238 14.7757 7.33133 14.7072L7.32966 14.706C6.74022 14.2743 5.58413 13.3493 4.53787 12.0609C3.4896 10.7701 2.5751 9.14369 2.41835 7.30488C2.18241 4.53326 4.24453 1.88466 6.93804 1.59261ZM4.91782 6.7496C4.91782 8.18845 6.06817 9.36542 7.49998 9.36542C8.93179 9.36542 10.0821 8.18845 10.0821 6.7496C10.0821 5.31074 8.93179 4.13378 7.49998 4.13378C6.06817 4.13378 4.91782 5.31074 4.91782 6.7496Z",
    stroke: "#2D3958",
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.05a506637309ea8acf7ec943ba8bb227.svg";
export { ForwardRef as ReactComponent };